// src/components/Sidebar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import { getVisibleTools } from '../data/buddyTools';

import { useAuth } from '@workos-inc/authkit-react';

// Icons
const HomeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>;
const ToolIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>;
const SettingsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>;
const CarrotIcon = () => <svg xmlns="http://www.w.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>;
const DocsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>;
const ShopIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>;
const LogoutIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>;

const Sidebar = ({ className, isOpen, onLogoutClick }) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (toolId) => {
    setOpenDropdown(openDropdown === toolId ? null : toolId);
  };

  const handleLogout = () => {
    signOut();
  };

  return (
    <aside className={`sidebar ${isOpen ? 'expanded' : ''} ${className || ''}`}>
      <div className="sidebar-content">
        <nav className="sidebar-nav">
          <ul className="sidebar-nav-list">
            <li className="sidebar-nav-item">
              <Link to="/home" className="sidebar-nav-link">
                <span className="sidebar-icon"><HomeIcon /></span>
                <span className="sidebar-text">Home</span>
              </Link>
            </li>
            <hr className="sidebar-divider" />
            {getVisibleTools().map((tool) => (
              <li key={tool.id} className="sidebar-nav-item">
                <div className="sidebar-tool-item">
                  <Link to={`/tool/${tool.id}`} className="sidebar-nav-link" target="_blank" rel="noopener noreferrer">
                    <span className="sidebar-icon"><ToolIcon /></span>
                    <span className="sidebar-text">{tool.title}</span>
                  </Link>
                  <button className="carrot-btn" onClick={() => handleDropdownToggle(tool.id)}>
                    <CarrotIcon />
                  </button>
                </div>
                {openDropdown === tool.id && isOpen && (
                  <ul className="dropdown-menu">
                    <li><Link to={`/tool/${tool.id}/config`}>Config</Link></li>
                    <li><Link to={`/tool/${tool.id}/settings`}>Settings</Link></li>
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
        <div className="sidebar-footer">
          <hr className="sidebar-divider" />
          <ul className="sidebar-nav-list">
            <li className="sidebar-nav-item">
              <Link to="/settings" className="sidebar-nav-link">
                <span className="sidebar-icon"><SettingsIcon /></span>
                <span className="sidebar-text">Settings</span>
              </Link>
            </li>
            <li className="sidebar-nav-item">
              <Link to="/docs" className="sidebar-nav-link">
                <span className="sidebar-icon"><DocsIcon /></span>
                <span className="sidebar-text">Documentation</span>
              </Link>
            </li>
            <li className="sidebar-nav-item">
              <Link to="/shop" className="sidebar-nav-link">
                <span className="sidebar-icon"><ShopIcon /></span>
                <span className="sidebar-text">Shop</span>
              </Link>
            </li>
            <li className="sidebar-nav-item">
              <button onClick={onLogoutClick} className="sidebar-nav-link">
                <span className="sidebar-icon"><LogoutIcon /></span>
                <span className="sidebar-text">Logout</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
